<template>
    <div 
        @scroll="continuesscroll"
        class="orderHistoryList">
            <div class="accordion" role="tablist">
                
                <template 
                        v-if="['xs', 'sm', 'md'].includes(windowsize.breakpoint)">

                        <mobile-order-history 
                            :groupedhistory="groupedhistory"
                            :changestatus.sync="changestatus"
                            :amendingorder.sync="amendingorder"
                            />

                        
                </template>

                <template v-if="['lg', 'xl', 'xxl'].includes(windowsize.breakpoint)">

                      <desktop-order-history  
                        :groupedhistory="groupedhistory"
                        :changestatus.sync="changestatus"
                        :amendingorder.sync="amendingorder"
                        />
                 
                </template>

               
            </div>

          

        <b-modal 
            id="cancelDeliverHistory" 
            centered
            hide-footer 
            hide-header>

            <img src="@/assets/cancelOrder.png" alt="">

            <h1>Amend Delivery?</h1>

            <div class="orderTrail" v-if="amendingorder">
                <div class="orderTrailItem">
                    <span 
                        :class="[`trailType`, 'done']">
                        <b-icon icon="box-seam"></b-icon>
                    </span>

                    <div class="trailDetails">
                        <h4>Delivered</h4>

                        <p>{{delivereddate(amendingorder) | forceformatdate('h:mm A, MMM D YYYY')}}</p>

                    </div>
                </div>
            </div>

            <p>This will only change the status of the order. The employee assignment will not change.</p>

            <b-form-textarea
                v-model="amendingnotes"
                placeholder="Write..."
                ></b-form-textarea>

             <b-form-checkbox
                v-if="changestatus"
                v-model="ischangestatus"
                :value="true"
                :unchecked-value="false"
                >
                Change delivery status
             </b-form-checkbox>



            <div class="modalAction">
                <button 
                    @click.prevent="$bvModal.hide('cancelDeliverHistory')"
                    class="btn btn-outline-primary">NEVER MIND</button>

                <button 
                     @click.prevent="startamendingorder"
                    class="btn btn-primary">CONTINUE</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
/**
 * Declerations
 */
// Plugins 
import axios from 'axios'
import moment from 'moment'

// helpers
import {getCollections, cleanrecord, addUpdateCollection} from '@/helpers/localbase'
import Helper from '@/helpers/helper'

// mixins
import {ordermixins} from '@/mixins/ordermixins'
import {orderboxmixins} from "@/mixins/orderboxmixins"

// components
import mobileorderhistory from '@/components/admin/mobileorderhistory'
import desktoporderhistory from '@/components/admin/desktoporderhistory'

export default {
    mixins : [ordermixins, orderboxmixins],
    components : {
        'mobile-order-history' : mobileorderhistory,
        'desktop-order-history': desktoporderhistory
    },
    data() {
        return {
            currentpage   : 1,
            maxpage       : 1,
            fetching      : false,
            groupedhistory: [],
            amendingorder : null,
            amendingnotes : '',
            changestatus  : false,
            ischangestatus: true,
        }
    },
    computed : {
        /**
         * Windows size
         * 
         */
        windowsize() {
            return this.$store.state.windowsize
        },
        /**
         * Socket / webhook
         */
        socketio () {
            return this.$store.state.socketio
        },
        /**
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        },
        /**
         * Employer history
         */
        history : {
            get() {
                return this.$store.state.employerhistory
            },
            set(list) {
                this.$store.commit('updateemployerhistory', list)
            }
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Force format date by 
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Get delivered date
         */
        delivereddate(order) {
            const status = order.orderstatuses.find(s => s.status == 'delivered');

            return status ? status.created_at : ''
        },
        /**
         * Amend order
         */
        async startamendingorder() {
            this.$bvModal.hide('cancelDeliverHistory')
            const url = `/update_order_status/${this.amendingorder.id}`

            await axios.post(url, {
                status             : 'amend',
                amend_change_status: this.ischangestatus,
                notes              : this.amendingnotes
            })

            
            this.getemployerhistory();
            
            if(this.socketio) {
                this.socketio.emit('broadcast', {
                    type  : 'assignorder',
                    userid: this.amendingorder.assign_order.assign_to.id
                })
            }
        },
        /**
         * Continues scroll fetching more history data
         */
        continuesscroll(){
            console.log('scrolling', this.maxpage , this.currentpage)
            if(this.maxpage >= this.currentpage) {
                if(!this.fetching) {
                    this.getemployerhistory(true)
                }
            }
        },
       
        /** 
         * Group history by date
        */
        historygrouping() {
            let   newlist = [];
            const format  = 'MM/DD/YYYY'

            this.history.forEach(order => {
                /**
                 *
                 * Check if order is nested or not
                 * 
                 */
                let orderdata = order;



                if(order.order) {
                    orderdata = order.order
                }  


                // moment(orderdata.updated_at).format(format)
                
                const date  =  Helper.formatdate(orderdata.updated_at, format, true);
                const group = newlist.find(g => moment(g.date).isSame(date, 'day'));

                console.log(orderdata, 'order history admin', date)


                if(group) {
                    newlist = newlist.map(g => {
                        if(moment(g.date).isSame(date, 'day')) {
                            g.orders = [...g.orders, order];
                        }
                        return g;
                    })
                } else {
                    const newgroup = {
                        date     : date,
                        orders   : [order]
                    }

                    newlist = [...newlist, newgroup]
                }
            })


            return newlist.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
        },
        /**
         * Get employer history
         * Pull from indexed db first
         */
        async getemployerhistory(page = false) {
                this.fetching = true
            let ihistory      = []

            if(this.history.length == 0 && !page) {
                 ihistory     = await getCollections({name : 'employerhistory'})
                 this.history = ihistory
            }

            const url = page ? `/all_orders?page=${this.currentpage + 1}` : `/all_orders`
            const res = await axios.get(url).catch(err => console.log(err))

            /**
             * Check if fetching new page or just loaded
             * 
             */
            this.history = !page ? [] : this.history; // reset empty to get new data

            if(res.data) {
                /**
                 * Merge history data 
                 * and check duplicate data and remove not assigned order
                 */
                const ahistory        = [...this.history, ...res.data.data]
                      this.history    = ahistory
                
                /**
                 * Get page data
                 */
                this.currentpage = res.data.current_page
                this.maxpage     = res.data.last_page

                for (let index = 0; index < ahistory.length; index++) {
                    const history = ahistory[index];
                    addUpdateCollection({name : "employerhistory",  data : history});
                }

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(ahistory, ihistory, 'id', 'employerhistory')

            } 

            /**
             * Resets
             */

            this.fetching       = false
            this.groupedhistory = this.historygrouping();

        }
    },
    /**
     * Run function before component render
     */
    beforeMount() {
        // get history
        this.getemployerhistory()
    }
}

</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";
@import "@/scss/partials/_mixins.scss";

.orderHistoryList {
    // max-height: 87vh;
    // overflow  : hidden auto;

    @include screen-min(lg) {
        max-height: initial;
        overflow  : initial;
    }

    .historyItem {
        padding-top: 30px;
        border-bottom: 10px solid $lightgrey;

        h1 {
            font-size: 20px;
            font-weight: 700;
            color: $primaryColor;
        }
    }


  
}

#cancelDeliverHistory {
    img {
        margin-left : auto;
        margin-right: auto;
        display     : block;
    }

    .modal-body {
        padding-left : 30px;
        padding-right: 30px;
        text-align   : center;
        
    }

    .orderTrail {
        display        : flex;
        justify-content: center;
        padding-left   : 0;

        .orderTrailItem {
            display   : block;
            text-align: center;

            .trailType {
                margin-right    : auto;
                margin-left     : auto;
                width           : 35px;
                height          : 35px;
                font-size       : 15px;
                border-radius   : 100%;
                display         : flex;
                align-items     : center;
                justify-content : center;
                background-color: $lightgrey;

                &.done {
                    background-color: $primaryColor;
                    color           : white;
                }
            }
        }
    }
}
</style>
